<template>
  <li v-if="!!amenityName" class="floor__info__amenity--directory" :class="customClasses">
    <component :is="`${derivedAmenityName}Icon`"></component>
  </li>
</template>

<script>
  import artLabIcon from '../icons/icon__art--lab--16.vue';
  import audioIcon from './../icons/icon__audio--24.vue';
  import barIcon from './../icons/icon__bar--24.vue';
  import cafeIcon from './../icons/icon__cafe--24.vue';
  import chargingStationIcon from './../icons/icon__charging-station--24.vue';
  import checkroomIcon from './../icons/icon__checkroom--24.vue';
  import checkroomMemberIcon from './../icons/icon__checkroom--member--24.vue';
  import filmDeskIcon from './../icons/icon__film-desk--24.vue';
  import infoIcon from './../icons/icon__info--24.vue';
  import membersIcon from './../icons/icon__members--24.vue'
  import relaxIcon from './../icons/icon__relax--24.vue';
  import restaurantIcon from './../icons/icon__restaurant--24.vue';
  import restroomsAllGenderIcon from './../icons/icon__restrooms--ag--24.vue';
  import restroomsIcon from './../icons/icon__restrooms--24.vue';
  import spacerIcon from './../icons/icon__spacer--24.vue';
  import storeIcon from './../icons/icon__store--24.vue';
  import ticketsIcon from './../icons/icon__tickets--24.vue';
  import wheelchairIcon from './../icons/icon__wheelchair--24.vue';
  import wheelchairPickupIcon from './../icons/icon__wheelchair--pickup--24.vue';


  export default {
    props: {
      amenityName: String,
    },
    components: {
      artLabIcon,
      audioIcon,
      barIcon,
      cafeIcon,
      chargingStationIcon,
      checkroomIcon,
      checkroomMemberIcon,
      filmDeskIcon,
      infoIcon,
      membersIcon,
      relaxIcon,
      restaurantIcon,
      restroomsAllGenderIcon,
      restroomsIcon,
      spacerIcon,
      storeIcon,
      ticketsIcon,
      wheelchairIcon,
      wheelchairPickupIcon
    },
    computed: {
      derivedAmenityName: function() {
        if (this.amenityName?.indexOf('Closed') > 0) {
          return this.amenityName.replace('Closed','');
        }
        return this.amenityName;
      },
      customClasses: function() {
        if (this.amenityName?.indexOf('Closed') > 0) {
          return '$color/alpha:33%';
        }
        return '';
      },
    },
  }
</script>
